import React, { useCallback } from 'react'
import styled from 'react-emotion'
import { SVGIcon, Tooltip } from 'shared/ui'
import themeVars from 'ui_theme/site/globals/site.variables'

const Hamburger = styled('div')`
  padding: 12px 16px;
  color: ${themeVars.ultraLight};
  cursor: pointer;
  transition: transform 150ms ease-in-out;
  line-height: 0;
  l &:hover {
    background-color: ${themeVars.dust};
  }
`

const StyledSvgIcon = styled(SVGIcon)`
  transition: all 75ms ease-in-out;
  ${({ rotated }) => rotated && `transform: rotate3d(0,0,1,-90deg);`};
`

const MenuButton = ({
  doToggleLeftSidebar,
  isLeftSidebarCollapsed,
  onClick,
}) => {
  const handleHamburgerClick = useCallback(
    e => {
      doToggleLeftSidebar()
      if (onClick) {
        onClick(e)
      }
    },
    [doToggleLeftSidebar, onClick]
  )

  return (
    <Tooltip
      position="right"
      tooltip={`${isLeftSidebarCollapsed ? 'Show' : 'Hide'} navigation`}
    >
      <Hamburger
        data-test-id="Hamburger"
        isActive={!isLeftSidebarCollapsed}
        onClick={handleHamburgerClick}
      >
        <StyledSvgIcon name="menu" size={16} rotated={isLeftSidebarCollapsed} />
      </Hamburger>
    </Tooltip>
  )
}

export default MenuButton
